/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionOnboarding } from './CompetitionOnboarding';
import {
    CompetitionOnboardingFromJSON,
    CompetitionOnboardingFromJSONTyped,
    CompetitionOnboardingToJSON,
    CompetitionOnboardingToJSONTyped,
} from './CompetitionOnboarding';
import type { RecurrenceConfig } from './RecurrenceConfig';
import {
    RecurrenceConfigFromJSON,
    RecurrenceConfigFromJSONTyped,
    RecurrenceConfigToJSON,
    RecurrenceConfigToJSONTyped,
} from './RecurrenceConfig';
import type { CompetitionStatus } from './CompetitionStatus';
import {
    CompetitionStatusFromJSON,
    CompetitionStatusFromJSONTyped,
    CompetitionStatusToJSON,
    CompetitionStatusToJSONTyped,
} from './CompetitionStatus';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { CompetitionItem } from './CompetitionItem';
import {
    CompetitionItemFromJSON,
    CompetitionItemFromJSONTyped,
    CompetitionItemToJSON,
    CompetitionItemToJSONTyped,
} from './CompetitionItem';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';

/**
 * Lightweight orchestration layer for competitions
 * @export
 * @interface Competition
 */
export interface Competition {
    /**
     * 
     * @type {string}
     * @memberof Competition
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Competition
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Competition
     */
    updatedAt: number;
    /**
     * Display name of the competition
     * @type {string}
     * @memberof Competition
     */
    name: string;
    /**
     * Optional description
     * @type {string}
     * @memberof Competition
     */
    description?: string;
    /**
     * 
     * @type {Array<CompetitionItem>}
     * @memberof Competition
     */
    items: Array<CompetitionItem>;
    /**
     * Whether this competition repeats
     * @type {boolean}
     * @memberof Competition
     */
    isRecurring?: boolean;
    /**
     * 
     * @type {RecurrenceConfig}
     * @memberof Competition
     */
    recurrence?: RecurrenceConfig;
    /**
     * If this is an instance, reference to parent template
     * @type {string}
     * @memberof Competition
     */
    templateId?: string;
    /**
     * Instance sequence number (Week 1, Week 2, etc.)
     * @type {number}
     * @memberof Competition
     */
    instanceNumber?: number;
    /**
     * Unix timestamp of when this instance was created
     * @type {number}
     * @memberof Competition
     */
    instanceDate?: number;
    /**
     * Groups related competitions under one event name
     * @type {string}
     * @memberof Competition
     */
    eventName?: string;
    /**
     * Reference to sponsoring Brand
     * @type {string}
     * @memberof Competition
     */
    sponsorId?: string;
    /**
     * Reference to hero Asset
     * @type {string}
     * @memberof Competition
     */
    hero?: string;
    /**
     * Reference to banner Asset
     * @type {string}
     * @memberof Competition
     */
    banner?: string;
    /**
     * 
     * @type {CompetitionOnboarding}
     * @memberof Competition
     */
    onboardingSection?: CompetitionOnboarding;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof Competition
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * 
     * @type {CompetitionStatus}
     * @memberof Competition
     */
    status: CompetitionStatus;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof Competition
     */
    prerequisites?: Array<PrerequisiteResponse>;
    /**
     * Unix ms when the competition was auto-paused by the staleness or game-health fallback. Absent when the competition is healthy.
     * @type {number}
     * @memberof Competition
     */
    atRiskPausedAt?: number;
    /**
     * Operator-internal context. Do NOT render verbatim in player-facing UI.
     * @type {string}
     * @memberof Competition
     */
    atRiskReason?: string;
    /**
     * 
     * @type {string}
     * @memberof Competition
     */
    atRiskScoringTemplateId?: string;
    /**
     * Unix ms when the CANCEL_REFUND fallback fired. Refund pipeline queue signal.
     * @type {number}
     * @memberof Competition
     */
    atRiskCancelledForRefundAt?: number;
    /**
     * MongoDB ObjectId of the OWGame this competition depends on for scoring.
     * @type {string}
     * @memberof Competition
     */
    scoringGameId?: string;
    /**
     * EventType ObjectIds required for scoring. Used for per-event-type granularity in game-health-based fallback.
     * @type {Array<string>}
     * @memberof Competition
     */
    requiredEventTypeIds?: Array<string>;
    /**
     * Min player rating to enter. Absent = no rating floor.
     * @type {number}
     * @memberof Competition
     */
    ratingFloor?: number;
    /**
     * Lower bound of rating-band eligibility. Absent = no band gate.
     * @type {number}
     * @memberof Competition
     */
    ratingBandMin?: number;
    /**
     * Upper bound of rating-band eligibility. Absent = no band gate.
     * @type {number}
     * @memberof Competition
     */
    ratingBandMax?: number;
    /**
     * Matchmaking pool isolation strategy. NONE = open; TRUST_TIER = isolate by computed tier; TRUST_FLOOR = block below floor.
     * @type {string}
     * @memberof Competition
     */
    poolIsolation?: CompetitionPoolIsolationEnum;
    /**
     * Minimum User.trustScore (0-100) required to enter this competition. Operator-tunable per-competition gate. Absent = no trust gate. Sprint 1 WU S1.4.1 — composes with the trust-score Prerequisite types so the eligibility check is consistent across competition entry paths.
     * @type {number}
     * @memberof Competition
     */
    trustScoreFloor?: number;
}


/**
 * @export
 */
export const CompetitionPoolIsolationEnum = {
    NONE: 'NONE',
    TRUST_TIER: 'TRUST_TIER',
    TRUST_FLOOR: 'TRUST_FLOOR'
} as const;
export type CompetitionPoolIsolationEnum = typeof CompetitionPoolIsolationEnum[keyof typeof CompetitionPoolIsolationEnum];


/**
 * Check if a given object implements the Competition interface.
 */
export function instanceOfCompetition(value: object): value is Competition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function CompetitionFromJSON(json: any): Competition {
    return CompetitionFromJSONTyped(json, false);
}

export function CompetitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Competition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'items': ((json['items'] as Array<any>).map(CompetitionItemFromJSON)),
        'isRecurring': json['isRecurring'] == null ? undefined : json['isRecurring'],
        'recurrence': json['recurrence'] == null ? undefined : RecurrenceConfigFromJSON(json['recurrence']),
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'instanceNumber': json['instanceNumber'] == null ? undefined : json['instanceNumber'],
        'instanceDate': json['instanceDate'] == null ? undefined : json['instanceDate'],
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'onboardingSection': json['onboardingSection'] == null ? undefined : CompetitionOnboardingFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'status': CompetitionStatusFromJSON(json['status']),
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'atRiskPausedAt': json['atRiskPausedAt'] == null ? undefined : json['atRiskPausedAt'],
        'atRiskReason': json['atRiskReason'] == null ? undefined : json['atRiskReason'],
        'atRiskScoringTemplateId': json['atRiskScoringTemplateId'] == null ? undefined : json['atRiskScoringTemplateId'],
        'atRiskCancelledForRefundAt': json['atRiskCancelledForRefundAt'] == null ? undefined : json['atRiskCancelledForRefundAt'],
        'scoringGameId': json['scoringGameId'] == null ? undefined : json['scoringGameId'],
        'requiredEventTypeIds': json['requiredEventTypeIds'] == null ? undefined : json['requiredEventTypeIds'],
        'ratingFloor': json['ratingFloor'] == null ? undefined : json['ratingFloor'],
        'ratingBandMin': json['ratingBandMin'] == null ? undefined : json['ratingBandMin'],
        'ratingBandMax': json['ratingBandMax'] == null ? undefined : json['ratingBandMax'],
        'poolIsolation': json['poolIsolation'] == null ? undefined : json['poolIsolation'],
        'trustScoreFloor': json['trustScoreFloor'] == null ? undefined : json['trustScoreFloor'],
    };
}

export function CompetitionToJSON(json: any): Competition {
    return CompetitionToJSONTyped(json, false);
}

export function CompetitionToJSONTyped(value?: Competition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'items': ((value['items'] as Array<any>).map(CompetitionItemToJSON)),
        'isRecurring': value['isRecurring'],
        'recurrence': RecurrenceConfigToJSON(value['recurrence']),
        'templateId': value['templateId'],
        'instanceNumber': value['instanceNumber'],
        'instanceDate': value['instanceDate'],
        'eventName': value['eventName'],
        'sponsorId': value['sponsorId'],
        'hero': value['hero'],
        'banner': value['banner'],
        'onboardingSection': CompetitionOnboardingToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'status': CompetitionStatusToJSON(value['status']),
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'atRiskPausedAt': value['atRiskPausedAt'],
        'atRiskReason': value['atRiskReason'],
        'atRiskScoringTemplateId': value['atRiskScoringTemplateId'],
        'atRiskCancelledForRefundAt': value['atRiskCancelledForRefundAt'],
        'scoringGameId': value['scoringGameId'],
        'requiredEventTypeIds': value['requiredEventTypeIds'],
        'ratingFloor': value['ratingFloor'],
        'ratingBandMin': value['ratingBandMin'],
        'ratingBandMax': value['ratingBandMax'],
        'poolIsolation': value['poolIsolation'],
        'trustScoreFloor': value['trustScoreFloor'],
    };
}

